import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import InsightsIndex from "@/pages/InsightsIndex";
import Article from "@/pages/Article";
import Finus from "@/pages/Finus";
import FinusDeleteAccount from "@/pages/FinusDeleteAccount";
import { Toaster } from "@/components/ui/sonner";

function CursorTorch() {
  useEffect(() => {
    // Only enable on fine pointers (desktops)
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    let raf = 0;
    let x = window.innerWidth / 2, y = window.innerHeight / 2;
    const el = document.documentElement;
    const onMove = (e) => {
      x = e.clientX;
      y = e.clientY;
      if (!raf) {
        raf = requestAnimationFrame(() => {
          el.style.setProperty("--mx", `${x}px`);
          el.style.setProperty("--my", `${y}px`);
          raf = 0;
        });
      }
    };
    window.addEventListener("mousemove", onMove, { passive: true });
    return () => window.removeEventListener("mousemove", onMove);
  }, []);
  return <div className="yg-torch" aria-hidden data-testid="cursor-torch" />;
}

function App() {
  return (
    <div className="App">
      <CursorTorch />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/insights" element={<InsightsIndex />} />
          <Route path="/insights/:slug" element={<Article />} />
          <Route path="/finus" element={<Finus />} />
          <Route path="/finus/delete-account" element={<FinusDeleteAccount />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-center" richColors />
    </div>
  );
}

export default App;
